import React, { useContext, useEffect, useRef, useState } from "react";
import './fileUploader.css';
import { toast } from "react-toastify";
import Chart from "react-apexcharts";
import { Link, useParams } from "react-router-dom";
import axiosClient from "../axios/axiosClient";
import Applayout from "./layout/applayout";

function ViewBeneficiary() {
  const {id} = useParams();
  const [beneficiary, setBeneficiary] = useState([]);
  const [loading, setLoading] = useState(false);

  const getBeneficiary = () => {
    axiosClient
      .get(`/beneficiaries/${id}`)
      .then((response) => {
        setBeneficiary(response.data.data)
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response.message);
      });
  };




const countBeneficiaryCasesByStatus = (beneficiaryCases, status) => {
    const filteredCases = beneficiaryCases.filter(caseItem => caseItem.status === status);
    return filteredCases.length;
}

  const [chartData, setChartData] = useState({
    options: {
      chart: {
        id: "basic-bar"
      },
      xaxis: {
        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      }
    },
    series: [
      {
        name: "case(s)",
        data: [0,0,0,0,0,0,0,0,0,0,0,0]
      }
    ],
    stroke: {
      curve: 'stepline',
    }
  });

  const getBeneficiaryData = (url=`/beneficiaries/${id}/analytics`) => {
    axiosClient.get(url)
          .then((response) => {
            var res = response.data.data
            const { months, cases } = res;
            setChartData((prevData) => ({
                ...prevData,
                options: {
                  ...prevData.options,
                  xaxis: {
                    categories: months, 
                  },
                },
                series: [
                  {
                    ...prevData.series[0],
                    data: cases, 
                  },
                ],
              }));
            setLoading(false)
          })
          .catch((error) => {
              setLoading(false)
              toast.error("error beneficiary's data");
          });
  }




  useEffect(() => {
    getBeneficiary()
    getBeneficiaryData()
  },[])



  return (
    <>
      <Applayout>
        <div className="page-body">
          <div className="container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col">
                  <div className="page-header-left">
                    <h3>Beneficiary</h3>
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i data-feather="home"></i>
                        </Link>
                      </li>
                      <li className="breadcrumb-item">Users</li>
                      <li className="breadcrumb-item active">view beneficiary</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container-fluid">
            <div className="edit-profile">
              <div className="row">
                <div className="col-xl-4">
                  <div className="card custom-card">
                    <div className="card-header">
                      <img
                        className="img-fluid"
                        src="../assets/images/user-card/3.jpg"
                        alt=""
                      />
                    </div>
                    <div className="card-profile">
                      <img
                        className="rounded-circle w-50"
                        src={beneficiary.photo || "../assets/images/avtar/user.jpeg"}
                        alt=""
                      />
                    </div>
                    <ul className="card-social">
                      <li>
                        <a href="general-widget.html#">
                          <i className="fa fa-facebook"></i>
                        </a>
                      </li>
                      <li>
                        <a href="general-widget.html#">
                          <i className="fa fa-google-plus"></i>
                        </a>
                      </li>
                      <li>
                        <a href="general-widget.html#">
                          <i className="fa fa-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a href="general-widget.html#">
                          <i className="fa fa-instagram"></i>
                        </a>
                      </li>
                      <li>
                        <a href="general-widget.html#">
                          <i className="fa fa-rss"></i>
                        </a>
                      </li>
                    </ul>
                    <div className="text-center profile-details">
                      <h4>{beneficiary.first_name} {beneficiary.last_name}</h4>
                      <h6>{beneficiary.email}</h6>
                      <h6>{beneficiary.phone_number}</h6>
                    </div>
                    
                    <div className="card-footer row">
                      <div className="col-4 col-sm-4">
                        <h6>Cases</h6>
                        <h3 className="counter">{beneficiary.beneficiary_cases?.length || 0}</h3>
                      </div>
                      <div className="col-4 col-sm-4">
                        <h6>Approved</h6>
                        <h3>
                          <span className="counter">{beneficiary.beneficiary_cases && countBeneficiaryCasesByStatus(beneficiary.beneficiary_cases, 'approved') || 0}</span>
                        </h3>
                      </div>
                      <div className="col-4 col-sm-4">
                        <h6>Declined</h6>
                        <h3>
                          <span className="counter"> <span className="counter">{beneficiary.beneficiary_cases && countBeneficiaryCasesByStatus(beneficiary.beneficiary_cases, 'declined') || 0}</span></span>
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-8 card">
                    <div className="card-header">
                      <h4 className="card-title mb-0">Profile Document</h4>
                      <div className="card-options">
                        <a
                          className="card-options-collapse"
                          href="edit-profile.html#"
                          data-toggle="card-collapse"
                        >
                          <i className="fe fe-chevron-up"></i>
                        </a>
                        <a
                          className="card-options-remove"
                          href="edit-profile.html#"
                          data-toggle="card-remove"
                        >
                          <i className="fe fe-x"></i>
                        </a>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="row">
                      <iframe
                        src={beneficiary.profile_upload}
                        width="100%"
                        height="500px"
                        title="Document Viewer"
                        />
                      </div>
                    </div>
                </div>

                <div className="col-xl-6 card">
                    <div className="card-header">
                      <h4 className="card-title mb-0">Beneficiary's Cases</h4>
                      <div className="card-options">
                        <a
                          className="card-options-collapse"
                          href="edit-profile.html#"
                          data-toggle="card-collapse"
                        >
                          <i className="fe fe-chevron-up"></i>
                        </a>
                        <a
                          className="card-options-remove"
                          href="edit-profile.html#"
                          data-toggle="card-remove"
                        >
                          <i className="fe fe-x"></i>
                        </a>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="row">
                      {!loading ?(<div className="table-responsive">
                            <table className="table card-table table-vcenter text-nowrap">
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Title</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                {beneficiary.beneficiary_cases &&
                                    beneficiary.beneficiary_cases.map((cas, index) => {
                                    const getStatusBadgeClass = (status) => {
                                        switch (status.toLowerCase()) {
                                        case "pending":
                                            return "badge bg-warning text-dark";
                                        case "in-progress":
                                            return "badge bg-primary";
                                        case "in-review":
                                            return "badge bg-info text-dark";
                                        case "completed":
                                            return "badge bg-success";
                                        case "declined":
                                            return "badge bg-danger";
                                        case "delivered":
                                            return "badge badge-delivered";
                                        default:
                                            return "badge bg-secondary";
                                        }
                                    };

                                    return (
                                        <tr>
                                        <td>{index + 1}</td>
                                        <td>{cas.title}</td>
                                       
                                        <td>${cas.amount.toLocaleString()}</td>
                                        <td>
                                            <span className={getStatusBadgeClass(cas.status)}>
                                            {cas.status}
                                            </span>
                                        </td>
                                        <td>
                                            <Link
                                            class="badge btn-secondary btn-sm"
                                            href="javascript:void(0)"
                                            data-bs-original-title=""
                                            title=""
                                            to={`/view-case/${cas.id}`}
                                            >
                                            <i class="fa fa-eye"></i> 
                                            </Link>
                                        </td>
                                        </tr>
                                    );
                                    })}
                                </tbody>
                            </table>
                            </div>)
                            :
                            (<div className="card">
                                <div className="alert alert-info">
                                    <h3 className="text-center">
                                        No Record Found
                                    </h3>
                                </div>
                            </div>)
                            }
                      </div>
                    </div>
                </div>
                <div className="col-xl-6 card">
                    <div className="card-header">
                      <h4 className="card-title mb-0">Graphical View</h4>
                      <div className="card-options">
                        <a
                          className="card-options-collapse"
                          href="edit-profile.html#"
                          data-toggle="card-collapse"
                        >
                          <i className="fe fe-chevron-up"></i>
                        </a>
                        <a
                          className="card-options-remove"
                          href="edit-profile.html#"
                          data-toggle="card-remove"
                        >
                          <i className="fe fe-x"></i>
                        </a>
                      </div>
                    </div>
                    <div className="card-body">
                    <Chart
                                options={chartData.options}
                                series={chartData.series}
                                type="area"
                                width="100%"
                            />
                    </div>
                </div>
                


              </div>
            </div>
          </div>
        </div>
      </Applayout>
    </>
  );
}

export default ViewBeneficiary;
